import React, { useState, useEffect } from "react";
import useRequest from "~/common/hooks/useRequest";

// Components
import useAlert from "~/common/hooks/useAlert";
import EvalCompInfo from "./component/EvalCompInfo";

// Assets
import { API_STATE } from "~/common/constants/state";
import EvalLeftInfo from "./component/EvalLeftInfo";
import EvalRighttInfo from "./component/EvalRighttInfo";
import EvaluatePopup from "./component/EvaluatePopup";
import { useTranslation } from "react-i18next";
import pageMaker from "~/common/constants/pageMaker";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import { useNavigate, useParams } from "react-router";
import {useGlobalStore} from "~/store";

const EvaluatePage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { idx } = useParams();
	const [
		{
			user: { info },
		},
	] = useGlobalStore();
	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				navigate(-1);
			}}
		>
			{t("pages.round.RoundManage.container.button02")}
		</button>,
	];

	const [applyResultModal, setApplyResultModal] = useState();
	const [companyDetailModal, setCompanyDetailModal] = useState();
	const [evalDetailData, setEvalDetailData] = useState({});
	const [evalListData, setEvalListData] = useState({});
	const [roundStatus, setRoundStatus] = useState("");

	// 로그인한 유저가 참여한 심사역인지 아닌지 판별
	const [isUserJudge, setIsUserJudge] = useState(false);


	const [totalNum, setTotalNum] = useState(0);
	const [evalFormData, setEvalFormData] = useState({
		roundIdx: Number(idx),
		name: "",
		page: 1,
		size: 10,
	});

	const evalDetailRequest = useRequest("get", "vc/round/review/detail");
	const viewEvalRequest = useRequest("post", "vc/round/review/list");
	const viewDetailRequest = useRequest("get", "vc/round/detail");

	const pageInfo = pageMaker(evalFormData.page, evalFormData.size, totalNum);
	const [curPage, setCurPage] = useState(1);

	const [showConfirmAlert, ConfirmAlert] = useAlert();

	const viewEvalPopup = (idx) => {
		evalDetailRequest.call(idx, "path");
	};
	useEffect(() => {
		switch (evalDetailRequest.state) {
			case API_STATE.done:
				const requestCompanyView = evalDetailRequest.response?.data;
				setEvalDetailData(requestCompanyView);
				setApplyResultModal(true);
				break;
			default:
				break;
		}
	}, [evalDetailRequest.state, evalDetailRequest.response, evalDetailData]);

	useEffect(() => {
		switch (viewEvalRequest.state) {
			case API_STATE.done:
				const requestEvaluateView = viewEvalRequest.response?.data;
				setTotalNum(requestEvaluateView?.total);
				setEvalListData(requestEvaluateView);
				break;
			default:
				break;
		}
	}, [viewEvalRequest.state, viewEvalRequest.response, evalListData]);

	useEffect(() => {
		if(info) {
			switch (viewDetailRequest.state) {
				case API_STATE.done:
					const requestCompanyView = viewDetailRequest.response?.data;
					const includeIdxCheck = viewDetailRequest.response?.data?.judge?.filter(item => item?.userIdx === info?.idx);
					if(includeIdxCheck?.length >= 1) {
						setIsUserJudge(true);
					} else {
						setIsUserJudge(false);
					}

					setRoundStatus(requestCompanyView?.round?.status);
					break;
				default:
					break;
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [info, viewDetailRequest.state, viewDetailRequest.response]);

	const getEvalData = () => {
		if (evalFormData.roundIdx !== 0) {
			viewEvalRequest.call(evalFormData);
		}
	};

	useEffect(() => {
		getEvalData();
	}, [evalFormData]);

	useEffect(() => {
		viewDetailRequest.call(idx, "path");
	}, []);

	const handlePage = (pageNum) => {
		setCurPage(pageNum);
		setEvalFormData({ ...evalFormData, page: pageNum });
	};

	return (
		<NavbarAndSidebarLayout
			menu={["round", "list"]}
			type={"main"}
			buttonList={headerButtons}
			menuName={"round-eval"}
		>
			<PageHeader />
			<div className="c__both-side-cardRow apply-result-wrap">
				<EvalLeftInfo evalListData={evalListData} />
				<EvalRighttInfo
					roundInfo={evalListData.round}
					isUserJudge={isUserJudge}
					pageInfo={pageInfo}
					handlePage={handlePage}
					setApplyResultModal={setApplyResultModal}
					evalListData={evalListData}
					setEvalFormData={setEvalFormData}
					evalFormData={evalFormData}
					viewEvalPopup={viewEvalPopup}
				/>
			</div>

			{/*---- 참여기업 모달*/}
			<EvaluatePopup
				evalListData={evalListData}
				evalDetailData={evalDetailData}
				setCompanyDetailModal={setCompanyDetailModal}
				showConfirmAlert={showConfirmAlert}
				applyResultModal={applyResultModal}
				setApplyResultModal={setApplyResultModal}
				getEvalData={getEvalData}
				pageInfo={pageInfo}
				viewtype={roundStatus === "심사중" || roundStatus === "지원마감"}
				handlePage={handlePage}
				viewEvalPopup={viewEvalPopup}
			/>

			{/*----기업정보 모달*/}
			<EvalCompInfo
				evalDetailData={evalDetailData}
				companyDetailModal={companyDetailModal}
				setCompanyDetailModal={setCompanyDetailModal}
			/>

			<ConfirmAlert
				message={t("pages.round.RoundList.evaluate.message")}
				type="success"
				confirm={t("pages.round.RoundList.evaluate.confirm")}
			/>
		</NavbarAndSidebarLayout>
	);
};

export default EvaluatePage;
